import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Outline gizmo for a 2D collision-shape resource, drawn as a line loop like Godot's editor
 * collision overlay. Component.tsx mounts it only when `showCollisions` is on.
 */
import { useMemo } from 'react';
import { decodeRectangleShape2D } from '../../../../resources/shapes/rectangleshape2d';
import { decodeCircleShape2D } from '../../../../resources/shapes/circleshape2d';
import { decodeCapsuleShape2D } from '../../../../resources/shapes/capsuleshape2d';
import { GizmoLine } from '../../../../r3f/components/GizmoLine';
import { godotPolylineToSegments } from '../../../../r3f/gizmo/godotPolylineToSegments';
import { warn } from '../../../../logger';
import { capsulePoints, circlePoints, rectanglePoints } from './collisionOutlines';
/** `[x0, y0, x1, y1, …]`, the flat form of `PackedVector2Array`. */
function flatten(points) {
    const flat = new Float32Array(points.length * 2);
    points.forEach(({ x, y }, index) => flat.set([x, y], index * 2));
    return flat;
}
export function CollisionGizmo2D({ shape, color, }) {
    const points = useMemo(() => {
        switch (shape.type) {
            case 'RectangleShape2D':
                return rectanglePoints(decodeRectangleShape2D(shape.data).size);
            case 'CircleShape2D':
                return circlePoints(decodeCircleShape2D(shape.data).radius);
            case 'CapsuleShape2D': {
                const { radius, height } = decodeCapsuleShape2D(shape.data);
                return capsulePoints(radius, height);
            }
            default:
                warn(`[CollisionShape2D] Unsupported shape type "${shape.type}" — drawing a unit rectangle.`);
                return rectanglePoints({ x: 20, y: 20 });
        }
    }, [shape.type, shape.data]);
    const positions = useMemo(() => godotPolylineToSegments(flatten(points), true), [points]);
    // Polyline segments (`GizmoLine`, a `<lineSegments>`), not a `wireframe` mesh, which shows the
    // triangulation diagonals of a circle or capsule.
    return positions && _jsx(GizmoLine, { positions: positions, color: color });
}
//# sourceMappingURL=CollisionGizmo2D.js.map